"use client";

import { Filter } from "@faire/deprecated-retailer-visitor-shared/components/Filters/Filter";
import { FilterName } from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterName";
import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";
import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { PrehydrationClickTrackingWrapper } from "@faire/deprecated-retailer-visitor-shared/lib/nextjs-rsc/PrehydrationClickTrackingWrapper";
import { useSearchPageIsRsc } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageIsRsc";
import { useSearchPageShouldNotShowAnyFiltersForLoggedIn } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageShouldNotShowAnyFiltersForLoggedIn";
import { useSearchPageFiltersIsLoading } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Filters/useSearchPageFiltersIsLoading";
import { useSearchPageFormattedTotalPrimaryResultsCount } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Filters/useSearchPageFormattedTotalPrimaryResultsCount";
import { useIsLoggedOutDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";
import { useIsLoggedOutDiscoverPerfAppTreatment } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPerfAppTreatment";
import { useSearchPageActionName } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/util/useSearchPageActionName";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import { getSpacing } from "@faire/web/slate/spacing";
import React from "react";
import styled from "styled-components";

export const MaybeSearchPageFilterSideBar = () => {
  const shouldNotShowFiltersForLoggedIn =
    useSearchPageShouldNotShowAnyFiltersForLoggedIn();

  if (shouldNotShowFiltersForLoggedIn) {
    return null;
  }

  return <SearchPageFilterSideBar />;
};

export const SearchPageFilterSideBar = () => {
  useTraceComponentRender("SearchPageFilterSideBar");

  const isLoading = useSearchPageFiltersIsLoading();
  const totalPrimaryResultsFormatted =
    useSearchPageFormattedTotalPrimaryResultsCount();

  return (
    <SearchPageFilterSideBarBase
      isLoading={isLoading}
      totalPrimaryResultsFormatted={totalPrimaryResultsFormatted}
    />
  );
};

const SearchPageFilterSideBarBase = React.memo(
  ({
    isLoading,
    totalPrimaryResultsFormatted,
  }: {
    isLoading: boolean;
    totalPrimaryResultsFormatted: string;
  }) => {
    const isLoggedInRetailer = useIsLoggedInRetailer();
    const isLoggedOutDiscover = useIsLoggedOutDiscoverPage();

    const isPerfDiscoverPageTreatment =
      useIsLoggedOutDiscoverPerfAppTreatment();

    const isSidebarWithFilterCollapse =
      isLoggedInRetailer || isLoggedOutDiscover;
    const actionName = useSearchPageActionName();
    const isRsc = useSearchPageIsRsc();
    // Check filter store, only return if isSideBarVisible is true
    const {
      data: { isSideBarVisible, isMobileModalOpen },
    } = useFilterStore(["isSideBarVisible", "isMobileModalOpen"]);

    if (isPerfDiscoverPageTreatment) {
      return null;
    }

    if (!isSideBarVisible && !isMobileModalOpen && isRsc) {
      return null;
    }

    return (
      <PrehydrationClickTrackingWrapper
        name={actionName}
        isRsc={isRsc}
        location="filter-sidebar"
      >
        <StyledFilter
          name={FilterName.SEARCH}
          resultsCount={totalPrimaryResultsFormatted}
          isLoading={isLoading}
          headerSeparator
          isSticky
          $withFilter={isSidebarWithFilterCollapse}
        />
      </PrehydrationClickTrackingWrapper>
    );
  }
);

const StyledFilter = styled(Filter)<{ $withFilter: boolean }>`
  margin-top: ${({ $withFilter }) =>
    $withFilter ? getSpacing("2x") : getSpacing("1x")};
  margin-right: ${getSpacing("2x")};
  ${({ $withFilter }) => ($withFilter ? "&& { width: unset; }" : undefined)};
`;
